import { render, staticRenderFns } from "./EditShipment.vue?vue&type=template&id=03f891e6&"
import script from "./EditShipment.vue?vue&type=script&lang=ts&"
export * from "./EditShipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports